import { render, staticRenderFns } from "./ItemLineConfiguration.vue?vue&type=template&id=25d183bc&scoped=true&"
import script from "./ItemLineConfiguration.vue?vue&type=script&lang=js&"
export * from "./ItemLineConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./ItemLineConfiguration.vue?vue&type=style&index=0&id=25d183bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d183bc",
  null
  
)

export default component.exports